import React, { useRef, useState } from "react";
import "./App.css";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/analytics";

import { useAuthState } from "react-firebase-hooks/auth";
import { useCollectionData } from "react-firebase-hooks/firestore";

firebase.initializeApp({
  // your config
  apiKey: "AIzaSyDJSNpRwgINOvGBH0Rnm8bG5yI9bAbkky8",
  authDomain: "qrride-group-chat.firebaseapp.com",
  projectId: "qrride-group-chat",
  storageBucket: "qrride-group-chat.appspot.com",
  messagingSenderId: "613188896330",
  appId: "1:613188896330:web:3c592ad52aad67134e48b3",
});

const auth = firebase.auth();
const firestore = firebase.firestore();
const analytics = firebase.analytics();

function Chat({ modalShow }) {
  const [user] = useAuthState(auth);
  const [modalShow1, setModalShow] = React.useState(modalShow);
  const handleclick = () => {
    setModalShow("chatpopup");
  };

  return (
    <div className={`${modalShow}`}>
      <div className='App2'>
        {/* <header></header> */}

        <section>{user ? <ChatRoom /> : <SignIn />}</section>
      </div>
    </div>
  );
}

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  };

  return (
    <>
      <button className='sign-in' onClick={signInWithGoogle}>
        Sign in with Google
      </button>
      <p>
        Do not violate the community guidelines or you will be banned for life!
      </p>
    </>
  );
}

function SignOut() {
  return (
    auth.currentUser && (
      <button
        className='sign-out'
        onClick={() => {
          auth.signOut();
        }}
      >
        Leave chat
      </button>
    )
  );
}

function ChatRoom() {
  const dummy = useRef();
  const messagesRef = firestore.collection("messages");
  const query = messagesRef.orderBy("createdAt").limit(25);

  const [messages] = useCollectionData(query, { idField: "id" });

  const [formValue, setFormValue] = useState("");

  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL,
    });

    setFormValue("");
    dummy.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div>
        <p>
          {" "}
          <SignOut />
        </p>
      </div>
      <main className='main1'>
        {messages &&
          messages.map((msg) => <ChatMessage key={msg.id} message={msg} />)}

        <span ref={dummy}></span>
        <form className='form1' onSubmit={sendMessage}>
          <input
            value={formValue}
            onChange={(e) => setFormValue(e.target.value)}
            placeholder='meet your fellow qrriders'
          />

          <button type='submit' disabled={!formValue}>
            send
          </button>
        </form>
      </main>
    </div>
  );
}

function ChatMessage(props) {
  const { text, uid, photoURL } = props.message;

  const messageClass = uid === auth.currentUser.uid ? "sent" : "received";

  return (
    <>
      <div className={`message ${messageClass}`}>
        <img
          src={
            photoURL || "https://api.adorable.io/avatars/23/abott@adorable.png"
          }
        />
        <p className='p-msg'>{text}</p>
      </div>
    </>
  );
}

export default Chat;
